import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { compose } from 'recompose'
import queryString from 'query-string'

import { wizard, meta } from 'helpers/decorators'
import { ConfigurationFile, ConfigurationWrapper } from 'containers/misc'
import { Account as AccountForm } from 'components/forms'
import { Checkbox } from 'components/fields'
import { Button, FormDebug, Title, Note } from 'components/misc'
import { apiAssessors, apiConfiguration } from 'helpers/decorators/api'
import { CONFIGURATION_KEYS } from 'constants/enums'
import validate from './account.validation'
import styles from './account.styl'

const enhance = compose(
  apiAssessors(),
  apiConfiguration(),
  wizard({
    form: 'assessorRegistration',
    multipage: true,
    validate,
    destroyOnUnmount: false
  }),
  meta({
    title: 'Account Details',
    intlKey: 'wizard.orb_account'
  })
)

class AccountDetails extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onCreateAssessor: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    leaders: PropTypes.object,
    values: PropTypes.object,
    location: PropTypes.object,
    configuration: PropTypes.object,
    onGetConfigurationValue: PropTypes.func.isRequired,
    onGetConfigurationValues: PropTypes.func.isRequired
  }

  componentDidMount = async () => {
    const { values } = this.props

    const organizationId = get(values, 'organizationId')

    const customization = await this.props.onGetConfigurationValues(
      [
        CONFIGURATION_KEYS.assessorRoleResponsibility.id,
        CONFIGURATION_KEYS.assessorCodeOfConduct.id,
        CONFIGURATION_KEYS.assessorRequirements.id,
        CONFIGURATION_KEYS.enablePrivacyPolicyAgreement.id
      ],
      organizationId,
      true
    )

    const isPrivacyPolicyAgreementEnabled = get(
      customization,
      `values[${CONFIGURATION_KEYS.enablePrivacyPolicyAgreement.id}].booleanValue`,
      false
    )

    if (isPrivacyPolicyAgreementEnabled) {
      await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.privacyPolicyUrl.id, organizationId, true)
    }
  }

  handleSubmit = fields => {
    const query = queryString.parse(get(this.props, 'location.search'))

    const authCode = get(query, 'authorizationCode')

    return this.props
      .onCreateAssessor(fields, authCode)
      .then(() => {
        this.props.onSubmit()
        this.props.reset()
      })
      .catch(err => console.debug(err))
  }

  render () {
    const { handleSubmit, values, leaders, configuration } = this.props

    const roleUrl = get(configuration, `values[${CONFIGURATION_KEYS.assessorRoleResponsibility.id}].fileUrl`)

    const conductUrl = get(configuration, `values[${CONFIGURATION_KEYS.assessorCodeOfConduct.id}].fileUrl`)

    const requirementsUrl = get(configuration, `values[${CONFIGURATION_KEYS.assessorRequirements.id}].fileUrl`)

    const isPrivacyPolicyAgreementEnabled = get(configuration, `values[${CONFIGURATION_KEYS.enablePrivacyPolicyAgreement.id}].booleanValue`)

    const privacyPolicyUrl = get(configuration, `values[${CONFIGURATION_KEYS.privacyPolicyUrl.id}].textValue`)

    const orgId = get(values, 'organizationId')

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Title intlKey="moduleTitle.online_record_book_account" h1>
          Online Record Book Account
        </Title>
        <Note intlKey="label.assessor_needs_account">
          To work on the Online Record Book (ORB) you need a personal ORB
          account. Please create your details here
        </Note>

        <AccountForm values={values} />
        <FormDebug values={values} />

        <div className="row">
          <div className="col-xs-12">
            <div style={{ float: 'left' }}>
              <Checkbox
                name="helpers.terms"
                label="I have read the <a href='{url}' target='_blank'>Terms and conditions and agree with them."
                intlKey="label.i_have_read_the_terms_and_conditions"
                intlValues={{
                  url: '/orb_parental_consent_form.pdf'
                }}
              />
            </div>

            <div style={{ float: 'left' }}>
              <ConfigurationFile
                configKey={CONFIGURATION_KEYS.termsAndConditionsAssessor.id}
                organizationId={get(values, 'organizationId')}
                isPublic
                formattedName={
                  <FormattedMessage
                    id="button.terms_and_conditions"
                    defaultMessage="International Terms & Conditions"
                  />
                }
              />
            </div>
            <div style={{ clear: 'both' }}></div>
            {isPrivacyPolicyAgreementEnabled &&
              privacyPolicyUrl && <div style={{ float: 'left' }}>
                <Checkbox
                  name="helpers.agreementPrivacyPolicy"
                  label="I have read the Privacy Policy and agree with. <a href='{url}' target='_blank'>The Privacy Policy is here.</a>"
                  intlKey="label.i_agree_to_privacy_policy"
                  intlValues={{
                    url: privacyPolicyUrl
                  }}
                /></div>}
            <div style={{ clear: 'both' }}></div>
            <div className={styles.agreementsWrapper}>
              {roleUrl && <div style={{ float: 'left' }}>
                <Checkbox
                  name="helpers.roleResponsibility"
                  label="I have read, understood and agree to the Role and Responsibilites of an Assessor / Supervisor. For more information <a href='{url}' target='_blank'>click here</a>."
                  intlKey="label.i_agree_to_role_and_responsibilities"
                  intlValues={{
                    url: roleUrl
                  }}
                /></div>}
            </div>


            <div className={styles.agreementsWrapper}>
              {conductUrl && <div style={{ float: 'left' }}>
                <Checkbox
                  name="helpers.agreementCodeOfConduct"
                  label="I Agree to Assessor Code of Conduct. For more information <a href='{url}' target='_blank'>click here</a>."
                  intlKey="label.i_agree_to_assessor_code"
                  intlValues={{
                    url: conductUrl
                  }}
                /></div>}
            </div>

            <div className={styles.agreementsWrapper}>
              {requirementsUrl && <div style={{ float: 'left' }}>
                <Checkbox
                  name="helpers.agreementRequirements"
                  label="I have read, understood and agree to Key conditions and requirements. For more information <a href='{url}' target='_blank'>click here</a>."
                  intlKey="label.i_agree_to_requirements"
                  intlValues={{
                    url: requirementsUrl
                  }}
                /></div>}
            </div>

            <div style={{ clear: 'both' }}></div>
            <div className={styles.agreementsWrapper}>
              <ConfigurationWrapper
                configKey={CONFIGURATION_KEYS.marketingMaterialsFromNao.id}
                type="booleanValue"
                orgId={orgId}
              >
                <Checkbox
                  name="helpers.marketingFromNao"
                  label="Opt in to receive marketing materials from the NAO."
                  intlKey="label.marketing_from_nao"
                />
              </ConfigurationWrapper>
            </div>

          </div>
        </div>

        <Button type="submit" disabled={get(leaders, 'loading')}>
          <FormattedMessage id="button.finish" defaultMessage="Finish" />
        </Button>
      </form>
    )
  }
}

export default enhance(AccountDetails)
